import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "Clients" }
const _hoisted_2 = { class: "Clients__create" }
const _hoisted_3 = { class: "Clients__search" }
const _hoisted_4 = { class: "Clients__list" }

import ClientsList from "@/components/pages/clients/ClientsList.vue";
import { computed } from "vue";
import { useClientStore } from "@/stores/clients";
import Search from "@/components/ds/search/Search.vue";
import ClientCreate from "@/components/pages/clients/ClientCreate.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const clientsStore = useClientStore();

const list = computed(() => {
    return clientsStore.sorted;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(ClientCreate)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(Search, {
        modelValue: _unref(clientsStore).search,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(clientsStore).search) = $event)),
        placeholder: "Zoeken..."
      }, null, 8, ["modelValue"]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(ClientsList, { list: list.value }, null, 8, ["list"])
      ])
    ])
  ]))
}
}

})